export const info = [
  {
    keyAlias: '1 / End',
    keyBind: 'kp_end',
  },
  {
    keyAlias: '2 / Down Arrow	',
    keyBind: 'kp_downarrow',
  },
  {
    keyAlias: '3 / Page Down',
    keyBind: 'kp_pgdn',
  },
  {
    keyAlias: '4 / Left Arrow',
    keyBind: 'kp_leftarrow',
  },
  {
    keyAlias: '5',
    keyBind: 'kp_5',
  },
  {
    keyAlias: '6 / Right Arrow',
    keyBind: 'kp_rightarrow',
  },
  {
    keyAlias: '7 / Home',
    keyBind: 'kp_home',
  },
  {
    keyAlias: '8 / Up Arrow',
    keyBind: 'kp_uparrow',
  },
  {
    keyAlias: '9 / Page Up',
    keyBind: 'kp_pgup',
  },
  {
    keyAlias: '0 / Insert',
    keyBind: 'kp_ins',
  },
  {
    keyAlias: '. / Delete',
    keyBind: 'kp_del',
  },
  {
    keyAlias: '/ (Slash)',
    keyBind: 'kp_slash',
  },
  {
    keyAlias: '* (Multiply)',
    keyBind: 'kp_home',
  },
  {
    keyAlias: '* (Multiply)',
    keyBind: 'kp_multiply',
  },
  {
    keyAlias: '- (Minus)',
    keyBind: 'kp_minus',
  },
  {
    keyAlias: '+ (Plus)',
    keyBind: 'kp_plus',
  },
  {
    keyAlias: 'Enter',
    keyBind: 'kp_enter',
  },
  {
    keyAlias: 'Insert',
    keyBind: 'ins',
  },
  {
    keyAlias: 'Delete',
    keyBind: 'del',
  },
  {
    keyAlias: 'Home',
    keyBind: 'home',
  },
  {
    keyAlias: 'End',
    keyBind: 'end',
  },
  {
    keyAlias: 'Page Up',
    keyBind: 'pgup',
  },
  {
    keyAlias: 'Page Down',
    keyBind: 'pgdn',
  },
  {
    keyAlias: 'Up Arrow',
    keyBind: 'uparrow',
  },
  {
    keyAlias: 'Left Arrow',
    keyBind: 'leftarrow',
  },
  {
    keyAlias: 'Down Arrow',
    keyBind: 'downarrow',
  },
  {
    keyAlias: 'Right Arrow',
    keyBind: 'rightarrow',
  },
  {
    keyAlias: 'F1',
    keyBind: 'f1',
  },
  {
    keyAlias: 'F2',
    keyBind: 'f2',
  },
  {
    keyAlias: 'F3',
    keyBind: 'f3',
  },
  {
    keyAlias: 'F4',
    keyBind: 'f4',
  },
  {
    keyAlias: 'F5',
    keyBind: 'f5',
  },
  {
    keyAlias: 'F6',
    keyBind: 'f6',
  },
  {
    keyAlias: 'F7',
    keyBind: 'f7',
  },
  {
    keyAlias: 'F8',
    keyBind: 'f8',
  },
  {
    keyAlias: 'F9',
    keyBind: 'f9',
  },
  {
    keyAlias: 'F10',
    keyBind: 'f10',
  },
  {
    keyAlias: 'F11',
    keyBind: 'f11',
  },
  {
    keyAlias: 'F12',
    keyBind: 'f12',
  },
  {
    keyAlias: '1 / !',
    keyBind: '1',
  },
  {
    keyAlias: '2 / @',
    keyBind: '2',
  },
  {
    keyAlias: '3 / #',
    keyBind: '3',
  },
  {
    keyAlias: '4 / $',
    keyBind: '4',
  },
  {
    keyAlias: '5 / %',
    keyBind: '5',
  },
  {
    keyAlias: '6 / ^',
    keyBind: '6',
  },
  {
    keyAlias: '7 / &',
    keyBind: '7',
  },
  {
    keyAlias: '8 / *',
    keyBind: '8',
  },
  {
    keyAlias: '9 / (',
    keyBind: '9',
  },
  {
    keyAlias: '0 / )',
    keyBind: '10',
  },
  {
    keyAlias: 'A',
    keyBind: 'a',
  },
  {
    keyAlias: 'B',
    keyBind: 'b',
  },
  {
    keyAlias: 'C',
    keyBind: 'c',
  },
  {
    keyAlias: 'D',
    keyBind: 'd',
  },
  {
    keyAlias: 'E',
    keyBind: 'e',
  },
  {
    keyAlias: 'F',
    keyBind: 'f',
  },
  {
    keyAlias: 'G',
    keyBind: 'g',
  },
  {
    keyAlias: 'H',
    keyBind: 'h',
  },
  {
    keyAlias: 'I',
    keyBind: 'i',
  },
  {
    keyAlias: 'J',
    keyBind: 'j',
  },
  {
    keyAlias: 'K',
    keyBind: 'k',
  },
  {
    keyAlias: 'L',
    keyBind: 'l',
  },
  {
    keyAlias: 'M',
    keyBind: 'm',
  },
  {
    keyAlias: 'N',
    keyBind: 'n',
  },
  {
    keyAlias: 'O',
    keyBind: 'o',
  },
  {
    keyAlias: 'P',
    keyBind: 'p',
  },
  {
    keyAlias: 'Q',
    keyBind: 'q',
  },
  {
    keyAlias: 'R',
    keyBind: 'r',
  },
  {
    keyAlias: 'S',
    keyBind: 's',
  },
  {
    keyAlias: 'T',
    keyBind: 't',
  },
  {
    keyAlias: 'U',
    keyBind: 'u',
  },
  {
    keyAlias: 'V',
    keyBind: 'v',
  },
  {
    keyAlias: 'W',
    keyBind: 'w',
  },
  {
    keyAlias: 'X',
    keyBind: 'x',
  },
  {
    keyAlias: 'Y',
    keyBind: 'y',
  },
  {
    keyAlias: 'Z',
    keyBind: 'z',
  },
  {
    keyAlias: 'Space Bar',
    keyBind: 'space',
  },
  {
    keyAlias: '- / _',
    keyBind: '-',
  },
  {
    keyAlias: '= / +',
    keyBind: '=',
  },
  {
    keyAlias: '[ / {',
    keyBind: '[',
  },
  {
    keyAlias: '] / }',
    keyBind: ']',
  },
  {
    keyAlias: '\\ / |',
    keyBind: '\\',
  },
  {
    keyAlias: '; / :',
    keyBind: 'semicolon',
  },
  {
    keyAlias: '\' / "',
    keyBind: "'",
  },
  {
    keyAlias: ', / <',
    keyBind: ',',
  },
  {
    keyAlias: '. / >',
    keyBind: '.',
  },
  {
    keyAlias: '/ / ?',
    keyBind: '/',
  },
  {
    keyAlias: 'Backspace',
    keyBind: 'backspace',
  },
  {
    keyAlias: 'Tab',
    keyBind: 'tab',
  },
  {
    keyAlias: 'Enter',
    keyBind: 'enter',
  },
  {
    keyAlias: 'Caps Lock',
    keyBind: 'capslock',
  },
  {
    keyAlias: 'Shift Left',
    keyBind: 'shift',
  },
  {
    keyAlias: 'Shift Right',
    keyBind: 'rshift',
  },
  {
    keyAlias: 'Control Left',
    keyBind: 'ctrl',
  },
  {
    keyAlias: 'Control Right	',
    keyBind: 'rctrl',
  },
  {
    keyAlias: 'Alt Left',
    keyBind: 'alt',
  },
  {
    keyAlias: 'Alt Right',
    keyBind: 'ralt',
  },
  {
    keyAlias: 'Left Mouse',
    keyBind: 'mouse1',
  },
  {
    keyAlias: 'Right Mouse',
    keyBind: 'mouse2',
  },
  {
    keyAlias: 'Middle Mouse',
    keyBind: 'mouse3',
  },
  {
    keyAlias: 'Side Mouse 1',
    keyBind: 'mouse4',
  },
  {
    keyAlias: 'Side Mouse 2',
    keyBind: 'mouse5',
  },
  {
    keyAlias: 'Mouse Wheel Down',
    keyBind: 'mwheeldown',
  },
  {
    keyAlias: 'Mouse Wheel Up',
    keyBind: 'mwheelup',
  },
];
